import type { XbotPageContext } from "@dto/pyxbot-agent.dto";

// The time window the page's graph controls show, kept by the controls themselves while they are on the screen.
// The app store's syncBoxCtx outlives them (it is never cleared), so it cannot say whether a page shows graphs at all;
// the Xbot chat reads this one to ask about what is shown.

export type ShownGraphWindow = XbotPageContext["window"];

let shown: ShownGraphWindow = null;

/** The controls pass `null` once they leave the screen. */
export function setShownGraphWindow(window: ShownGraphWindow): void {
  shown = window || null;
}

export function shownGraphWindow(): ShownGraphWindow {
  return shown;
}
